import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import React, { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';

export interface DoorsAdminSearchFilter {
  textFilter?: string;
}

interface Props {
  onFilterChanged: (filter: DoorsAdminSearchFilter) => void;
}

export default function DoorsAdminFilter(props: Props) {
  const [filter, setFilter] = useState<DoorsAdminSearchFilter>({});
  const [textCriteria, setTextCriteria] = useState<string | undefined>();
  const [debouncedTextCriteria] = useDebounce(textCriteria, 300); // this is to prevent calling the api with every key stroke in the text input.

  useEffect(() => {
    if (filter && props.onFilterChanged) {
      props.onFilterChanged(filter);
    }
  }, [filter, props]);

  useEffect(() => {
    setFilter((prevFilter) => {
      return { ...prevFilter, textFilter: debouncedTextCriteria };
    });
  }, [debouncedTextCriteria, setFilter]);

  const onTextCriteriaChanged = (event: any) => {
    setTextCriteria(event.currentTarget.value);
  };

  return (
    <Box display="flex" flexDirection="row" justifyContent="flex-end">
      <Box display="flex" flexDirection="row">
        <Box p={1}>
          <TextField variant="outlined" name="textCriteria" label="Search by DDS Id" onChange={onTextCriteriaChanged} />
        </Box>
      </Box>
    </Box>
  );
}
